export default {
  computed: {
    rootClasses() {
      const hasActions = this.$scopedSlots && this.$scopedSlots.actions
      const { placeholder, disabled } = this.$attrs

      const classes = [
        ...this.bemFacets,
        this.bemAdd(this.hasFloatingLabel ? 'floating-label' : ''),
        this.bemAdd(this.hasErrors ? 'has-error' : ''),
        this.bemAdd(this.$attrs.required ? 'is-required' : 'is-optional'),
        this.bemAdd(this.$attrs.disabled ? 'is-disabled' : ''),
        this.bemAdd(this.hasFocus ? 'has-focus' : ''),
        this.bemAdd(hasActions ? 'has-actions' : ''),
        this.bemAdd(this.currentValue ? 'is-filled' : 'is-empty'),
      ]

      // NOTE: Extend the form classes adding also the floating variants
      if (this.hasFloatingLabel) {
        const isFloating = placeholder || this.currentValue || this.hasFocus || disabled
        classes.push(this.bemAdd(isFloating ? 'is-floating' : ''))
      }

      return classes
    },
  },
}
